import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faSun, faMoon,faCloudSun, faGraduationCap, faBox, fa2, faGrin } from '@fortawesome/free-solid-svg-icons';
// import { getAllCourses } from '../../redux/actions/courses';
import { getAllSkills } from '../../../redux/actions/skills';
// import { setOnboardingData } from '../../redux/actions/authentication';
import Spinner from '../../../components/Spinner';
import { faDropbox } from '@fortawesome/free-brands-svg-icons';
import ConfirmationModal from './ConfirmationModal';
// import { Mixpanel } from '../../config/Mixpanel';
// import Constants from '../../common/constants';


const SettingsTab = ({skillData ,setTilebarItem}) => {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const wa_code = useSelector((store) => store?.profileDetails?.wa_code);
  const [allCourses, setAllCourses] = useState([]);
  const [skills, setSkills] = useState([]);
  const [courseSlug, setCourseSlug] = useState(null);
  const [courseName, setCourseName] = useState(null);
  const [selectedSkill , setSelectedSkill] = useState({});
  const [firstMSkill, setFirstMSkill] = useState(null);
  const [firstLesson, setFirstLesson] = useState(null);
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openConfirmationModal , setOpenConfirmationModal ] = useState(false);
  const {skill_slug} = useParams();
  const [currentSkill , setCurrentSkill] = useState({});
  const all_courses = useSelector(store => store?.courses?.allCourses)
  
  useEffect(() => {
    setIsLoading(true)
      setAllCourses(all_courses);
      setIsLoading(false)
}, [])

  const handleClick = (item) => {
    if (step === 1) {
      setStep(step + 1);
      setIsLoading(true);
      dispatch(
        getAllSkills(item?.course_slug, (res) => {
          setSkills(res);
          setIsLoading(false);
        })
      );
      //Mixpanel.track(Constants.Mixpanel.ONBOARDING_STEP_ONE);
    } else if (step === 2) {
      
      setSelectedSkill(item);
      setOpenConfirmationModal(true);

      // Mixpanel.track(Constants.Mixpanel.ONBOARDING_STEP_TWO);
    }
  };

  const stepStr = [
    "Select the area you are interested in:",
    `Select a Skill in ${courseName}`,
    "When do you generally like to Learn?",
  ];
  console.log('skilldtaa' , skillData)
  console.log(skill_slug , 'skill_slug');
  console.log(currentSkill , 'currentskill');
  return (
    <div className='w-full'>
      {!isLoading ? (
        <div className="mb-2 w-full overflow-y-auto ">
         <div className='flex flex-row  justify-center items-center w-full bg-[#086788] text-white px-2 py-2 rounded-lg text-sm'>
         <div class="grid grid-cols-2 grid-rows-2 gap-[2px] mr-2" >
            <div className='border-white border-[1px] bg-[#086788] w-[6px] h-[6px]'></div>
            <div className='border-white border-[1px] bg-[#086788] w-[6px] h-[6px]'></div>
            <div className='border-white border-[1px] bg-[#086788] w-[6px] h-[6px]'></div>
            <div className='border-white border-[1px] bg-[#086788] w-[6px] h-[6px]'></div>
        </div>
          <div className='flex flex-row justify-between items-center w-full'>
            <div>Change Course</div>
            <div>Step {step}/2</div>
          </div>
         </div>
          {step === 1 && (
            <div className="my-3 mx-auto grid grid-cols-1 gap-2 px-2 md:w-full md:grid-cols-2 md:gap-5">
              {allCourses?.map((course) => (
                <div
                  className="flex cursor-pointer items-center gap-2 overflow-hidden rounded-lg bg-white hover:bg-teal-500"
                  key={course?.course_slug}
                  onClick={() => handleClick(course)}
                >
                  <div className="flex h-14 w-14 items-center justify-center bg-gray-200 p-2">
                    <img
                      src={course?.course_icon?.url}
                      alt="Course Icon"
                      className="h-8 object-cover"
                    />
                  </div>
                  <p className="text-center text-sm font-semibold text-gray-700">
                    {course?.["course-name"]?.replace("Course", "")}
                  </p>
                  <div className="flex-1"></div>
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    size="xl"
                    className="mr-3 text-gray-700"
                  />
                </div>
              ))}
            </div>
          )}
          {step === 2 && (
            <div className="my-3 mx-auto grid grid-cols-1 gap-2 px-2 md:w-full md:grid-cols-2 md:gap-5">
              {skills?.map((skill) => (
                <div
                  className="flex cursor-pointer items-center gap-2 overflow-hidden rounded-lg bg-white hover:bg-teal-500"
                  key={skill?.skill_slug}
                  onClick={() => handleClick(skill)}
                >
                  <div className="flex h-14 w-14 items-center justify-center bg-gray-200 p-2">
                    <img
                      src={skill?.skill_thumbnail}
                      alt="Course Icon"
                      className="h-8 object-cover"
                    />
                  </div>
                  <p className="text-center text-sm font-semibold text-gray-700">
                    {skill?.["skill-name"]}
                  </p>
                  <div className="flex-1"></div>
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    size="xl"
                    className="mr-3 text-gray-700"
                  />
                </div>
              ))}
            </div>
          )}
          {
            openConfirmationModal && <ConfirmationModal isModalEnabled={openConfirmationModal} setIsModalEnabled={setOpenConfirmationModal} selectedSkill={selectedSkill} currentSkill={skillData} setTilebarItem={setTilebarItem}/>
          }
        </div>
      ) : (
        <div className="mb-2 w-full overflow-y-auto">
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default SettingsTab;
